import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Datenschutz } from "./pages/datenschutz";
import { Impressum } from "./pages/Impressum";
import { Rangliste } from "./pages/Rangliste";
import { Teilnehmerliste } from "./pages/Teilnehmerliste";
import { Anmeldung } from "./pages/Anmeldung";
import { LandingPage } from "./landingpage/LandingPage";

export default function App() {

    return (
        <>
           {/* <Provider store={store}>
                <AuthDialogLogin />
                <AuthDialogSignUp />
                <AuthDialogMailRegistered />
                <AuthDialogSendRegistrationMail />
                <AuthDialogPasswordReset />
                <AuthDialogPasswordResetMail />
                <AuthDialogCreateNewPassword />
                <AuthDialogCreateNewPasswordConfirm />*/}

                <Routes>
                    <Route path="/" element={<LandingPage />}></Route>
                    <Route path="/anmeldung" element={<Anmeldung />}></Route>
                    <Route path="/teilnehmerliste" element={<Teilnehmerliste />}></Route>
                    <Route path="/rangliste" element={<Rangliste />}></Route>
                    <Route path="/impressum" element={<Impressum />}></Route>
                    <Route path="/datenschutz" element={<Datenschutz />}></Route>
                   {/* <Route path="/contact" element={<FooterContact />}></Route>
                    <Route path="/imprint" element={<FooterImprint />}></Route>
                    <Route path="/dataprotection" element={<FooterDataprotection />}></Route>

                    <Route path="/auftrag/search" element={<ProtectedRoute><AuftragSearch /></ProtectedRoute>}></Route>
                    <Route path="/auftrag/details" element={<ProtectedRoute><AuftragDetails /></ProtectedRoute>}></Route>
                    <Route path="/kunde" element={<ProtectedRoute><KundeSearch /></ProtectedRoute>}></Route>

                    <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>}></Route>

                    <Route path="/passwordreset/:uid" element={<PasswordResetLink />}></Route>
                    */}
                </Routes>
            {/*</Provider>*/}
        </>
    );
}
